export const mediumProblems = [
    {
        id: 2,
        title: "Add Two Numbers",
        solution_src: "https://leetcode.com/problems/add-two-numbers/discuss/1216080/C++-or-Using-Carry"
    },
    {
        id: 3,
        title: "Longest Substring Without Repeating Characters",
        solution_src: "https://leetcode.com/problems/longest-substring-without-repeating-characters/discuss/1227936/Simple-Approach-or-C++"
    },
    {
        id: 5,
        title: "Longest Palindromic Substring",
        solution_src: "https://leetcode.com/problems/longest-palindromic-substring/discuss/1219351/C-Solution"
    },
    {
        id: 8,
        title: "String to Integer (atoi)",
        solution_src: "https://leetcode.com/problems/string-to-integer-atoi/discuss/1219352/C++-Solution"
    },
    {
        id: 11,
        title: "Container With Most Water",
        solution_src: "https://leetcode.com/problems/container-with-most-water/discuss/1225959/Simple-C++-Solution"
    },
    {
        id: 15,
        title: "3Sum",
        solution_src: "https://leetcode.com/problems/3sum/discuss/1225963/Simple-C++-Solution"
    },
    {
        id: 17,
        title: "Letter Combinations of a Phone Number",
        solution_src: "https://leetcode.com/problems/letter-combinations-of-a-phone-number/discuss/1176157/C%2B%2B-or-100-Faster-or-Easy-to-Understand-or-Using-vector-as-a-queue"
    },
    {
        id: 19,
        title: "Remove Nth Node From End of List",
        solution_src: "https://leetcode.com/problems/remove-nth-node-from-end-of-list/discuss/1223779/Simple-C++-Solution"
    },
    {
        id: 22,
        title: "Generate Parentheses",
        solution_src: "https://leetcode.com/problems/generate-parentheses/discuss/1221551/C++-or-Simple-Solution-or-Stack"
    },
    {
        id: 24,
        title: "Swap Nodes in Pairs",
        solution_src: "https://leetcode.com/problems/swap-nodes-in-pairs/discuss/1234203/Simple-C-Solution-or-0ms"
    },
    {
        id: 33,
        title: "Search in Rotated Sorted Array",
        solution_src: "https://leetcode.com/problems/search-in-rotated-sorted-array/discuss/1208131/Easy-to-Understand-or-C++-or-Binary-Search-or-100-faster"
    },
    {
        id: 34,
        title: "Find First and Last Position of Element in Sorted Array",
        solution_src: "https://leetcode.com/problems/find-first-and-last-position-of-element-in-sorted-array/discuss/1223789/C++-Binary-Search-Solution"
    },
    {
        id: 36,
        title: "Valid Sudoku",
        solution_src: ""
    },
    {
        id: 48,
        title: "Rotate Image",
        solution_src: "https://leetcode.com/problems/rotate-image/discuss/1221555/Simple-C++-Solution"
    },
    {
        id: 61,
        title: "Rotate List",
        solution_src: "https://leetcode.com/problems/rotate-list/discuss/1222832/Simple-C++-Solution"
    },
    {
        id: 62,
        title: "Unique Paths",
        solution_src: "https://leetcode.com/problems/unique-paths/discuss/1193931/C++-or-Dynamic-Programming-or-0ms-or-100-faster"
    },
    {
        id: 64,
        title: "Minimum Path Sum",
        solution_src: "https://leetcode.com/problems/minimum-path-sum/discuss/1221703/Easy-C++-Solution"
    },
    {
        id: 75,
        title: "Sort Colors",
        solution_src: ""
    },
    {
        id: 78,
        title: "Subsets",
        solution_src: "https://leetcode.com/problems/subsets/discuss/1207436/Simple-Approach-or-C++"
    },
    {
        id: 80,
        title: "Remove Duplicates from Sorted Array II",
        solution_src: "https://leetcode.com/problems/remove-duplicates-from-sorted-array-ii/discuss/1222863/No-Extra-Space-or-100-faster-or-C++"
    },
    {
        id: 102,
        title: "Binary Tree Level Order Traversal",
        solution_src: "https://leetcode.com/problems/binary-tree-level-order-traversal/discuss/1221548/Using-C++-or-Queue"
    },
    {
        id: 114,
        title: "Flatten Binary Tree to Linked List",
        solution_src: "https://leetcode.com/problems/flatten-binary-tree-to-linked-list/discuss/1234188/C++-or-Iterative-or-Stack"
    },
    {
        id: 215,
        title: "Kth Largest Element in an Array",
        solution_src: "https://leetcode.com/problems/kth-largest-element-in-an-array/discuss/1219357/Simple-C++-Solution-or-Using-Priority-Queue"
    },
    {
        id: 230,
        title: "Kth Smallest Element in a BST",
        solution_src: "https://leetcode.com/problems/kth-smallest-element-in-a-bst/discuss/1234174/C++-Solution-or-InOrder-Traversal"
    },
    {
        id: 318,
        title: "Maximum Product of Word Lengths",
        solution_src: "https://leetcode.com/problems/maximum-product-of-word-lengths/discuss/1234139/Simple-C++-Solution"
    },
    {
        id: 347,
        title: "Top K Frequent Elements",
        solution_src: "https://leetcode.com/problems/top-k-frequent-elements/discuss/1225941/C++-or-Using-Priority-Queue-and-Hashmap"
    },
    {
        id: 1268,
        title: "Search Suggestions System",
        solution_src: "https://leetcode.com/problems/search-suggestions-system/discuss/1243109/Simple-C++-Solution"
    },
    {
        id: 1423,
        title: "Maximum Points You Can Obtain from Cards",
        solution_src: "https://leetcode.com/problems/maximum-points-you-can-obtain-from-cards/discuss/1219365/Easy-C++-Solution"
    },
]
